import { UseFormReturn } from "react-hook-form";
import { withContext, withUseFormHook } from "@/common/utils/withContext";
import { connect } from "react-redux";
import { Business } from "@mui/icons-material";
import { EvesModal } from "@/common/components/molecules/modal/modal";
import { formSchema } from "@/modules/user/shared/schemas/paymentFormSchema";
import AddConnectdAccount from "./addConnectdAccount";
import {
  ConnectedAccountModel,
  IConnectedAccountFormPropsModel,
} from "@/modules/integrationSettings/shared/models/integrationSettings";
import { useMutation } from "react-query";
import { NotifyType } from "@/common/utils/notificationService";
import { createBillingAccount } from "@/services/integrationSettings";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { HTTPError } from "@/common/enums/enums";
import store from "@/store";
import { setLoader } from "@/store/app/reducer";

const connnectedAccountForm = (props: IConnectedAccountFormPropsModel) => {
  const { t: translate } = useTranslation();
  const connectedAccountForm: any = props.formService as UseFormReturn<
    ConnectedAccountModel,
    any
  >;
  const superAdmin = props.superAdmin;
  const [selectedUserType, setSelectedUserType] = useState("existing");

  const tabsConfig = [
    {
      name: `${translate("accounts.list.add_account")}`,
      icon: <Business />,
      component: (
        <AddConnectdAccount
          connectedAccountForm={connectedAccountForm}
          superAdmin={superAdmin}
          tenantId={props?.tenantId}
          selectedUserType={selectedUserType}
          setSelectedUserType={setSelectedUserType}
        />
      ),
      visible: true,
    },
  ];
  const { mutate: saveConnectedUser } = useMutation(
    (billingAccount: any) => createBillingAccount(billingAccount),
    {
      onMutate: () => {
        store.dispatch(setLoader(true));
      },
      onSettled: () => {
        store.dispatch(setLoader(false));
      },
      onSuccess: (data: any) => {
        const notify: NotifyType = {
          message: "",
          type: "success",
        };
        if (data.status === "Success") {
          notify.message = `${translate("accounts.message.success_message")}`;
          notify.type = "success";
          props.notificationService?.notify(notify);
          // Close only on success
          props.onFormClose();
          props.fetchAllConnectedAccounts();
        } else {
          // Keep modal open
          const errorResponse = data?.data;
          const parsedError =
            errorResponse && typeof errorResponse === "string"
              ? JSON.parse(errorResponse)
              : "";

          // if (
          //   [HTTPError.CANNOT_ACQUIRE_LOCK, HTTPError.GENERAL_ERROR].includes(data?.status)
          // ) {
          //   const errorData = JSON.parse(data?.data);
          //   notify.message = errorData?.errorMessage;
          // } else {
          //   const userEmail = connectedAccountForm.getValues("user.email");
          //   notify.message = `${translate(
          //     "accounts.message.create_error"
          //   ).replace(/{{userEmail}}/g, `'${userEmail || "this email"}'`)}`;
          // }

          const backendMessage = parsedError?.errorMessage || "";

          if (
            backendMessage.toLowerCase().includes("email") &&
            backendMessage.toLowerCase().includes("already exist")
          ) {
            notify.message =
              "Email already exists. Please use the Existing User option instead.";
          } else {
            notify.message = backendMessage;
          }
          notify.type = "error";
          props.notificationService?.notify(notify);
        }
      },
      onError: () => {
        const notify: NotifyType = {
          message:
            "Failed to create connected account, Please try again or contact support",
          type: "error",
        };
        props.notificationService?.notify(notify);
      },
    }
  );

  const onFormSubmit = (formData: any) => {
    const billingAccount =
      selectedUserType === "existing"
        ? {
            id: formData.id,
            companyName: formData.companyName,
            businessOwnerID: formData.userID,
            siteIDs: formData.sites?.map((site: any) => site.id) || [],
          }
        : {
            id: null,
            businessOwnerID: null,
            companyName: formData.companyName,
            user: formData.user,
            siteIDs: formData.sites?.map((site: any) => site.id) || [],
          };

    saveConnectedUser(billingAccount);
  };

  const onHandleClose = () => {
    if (connectedAccountForm.formState.isDirty === true) {
      //based on the formValidity confirmation Dialogtype changes
      if (connectedAccountForm.formState.isValid) {
        props.dialogService?.showConfirm(
          {
            confirmType: "DIRTY_CHANGE_CLOSE",
          },
          (result) => {
            if (result === "SAVE") {
              connectedAccountForm.handleSubmit(onFormSubmit)();
            } else if (result === "CLOSE") {
              props.onFormClose();
              props.resetConnectedAccountForm("");
            }
          }
        );
      } else {
        props.dialogService?.showConfirm(
          {
            confirmType: "INVALID_CHANGE_CLOSE",
          },
          (result: string) => {
            if (result === "CLOSE") {
              props.onFormClose();
              props.resetConnectedAccountForm("");
            }
          }
        );
      }
    } else {
      props.onFormClose();
      props.resetConnectedAccountForm("");
    }
  };
  const isSaveEnable = connectedAccountForm.formState.isValid;
  return (
    <>
      <EvesModal
        maxHeight={"420px"}
        maxWidth={"900px"}
        isOpen={props.showConnectedAccountForm}
        onHandleSave={connectedAccountForm.handleSubmit(onFormSubmit)}
        onHandleClose={onHandleClose}
        isSaveDisabled={!isSaveEnable}
        tabsConfig={tabsConfig}
        modalType="tabs"
        isSaveHidden={false}
      ></EvesModal>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  userInfo: state.userContext.userInfo,
});

export default connect(mapStateToProps)(
  withContext(
    withUseFormHook(connnectedAccountForm, {
      schema: formSchema,
      defaultValues: { ...new ConnectedAccountModel() },
      context: { shouldValidateSites: true },
    })
  )
);
